import React from "react";

import { jwtDecode } from "jwt-decode";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import SettingsIcon from "@material-ui/icons/Settings";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import FormControl from "@material-ui/core/FormControl/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { getUserGroups } from "../../assets/helpers/utilityHelper";

import {API_ROOT} from 'api-config';
import axios from "axios";

const style = {
  dialogPaper: {
    minHeight: '60vh',
    maxHeight: '80vh',
  },
  ...userProfileStyles
};
const userGroups = getUserGroups()
class Settings extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      dentistList: [{id: 0, name: 'loading...'}],
      selectedMimicUser: '',
      searchString: '',
      searchResults: [],
      searchResultsError: ''
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getDentistList()
  }

  getDentistList() {

    axios.get(`${API_ROOT}/provider/?allProviders=true&openAccountsOnly=true`, {headers: getApiHeaders()})
      .then(res => this.setDentistList({responseMessage: res.data}));
  }

  setDentistList(res) {
    if (this._isMounted) {
      this.setState({
        dentistList: res.responseMessage
      })
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeMimicUser = (event, viewingAsUserType = '', userId = '', viewingAs = '') => {
    const eventValue = event.target.value
    var selectedMimicUser;
    const allRemoveUserTypes = ['organization', 'patient']
    var i;
    for (i = 0; i < allRemoveUserTypes.length; i++) {
      const index = userGroups.indexOf(allRemoveUserTypes[i]);
      if (index > -1) {
        userGroups.splice(index, 1);
      }
    }
    if (eventValue) {
      selectedMimicUser = eventValue
      userId = eventValue
      viewingAs = event._targetInst.pendingProps.children[0]
    } else if (userId !== '') {
      selectedMimicUser = userId
    } else {
      var decodedJwt = jwtDecode(sessionStorage.getItem('jwtToken'))
      selectedMimicUser = ''
      userId = decodedJwt['user_id']
      viewingAs = ''
    }
    const mimicData = {
      userId: userId
    }
    axios.post(`${API_ROOT}/mimic/`, mimicData, { headers: getApiHeaders() })
      .then(res => this.handleChangeMimicUserResponse(res, selectedMimicUser, userId, viewingAs, viewingAsUserType));

  };

  handleChangeMimicUserResponse(res, selectedMimicUser, userId, viewingAs, viewingAsUserType) {
    if (res.data.message && res.data.message === 'success') {
      this.setState({ selectedMimicUser: selectedMimicUser });
      if (selectedMimicUser !== '') {
        if (!userGroups.includes(viewingAsUserType)) {
          userGroups.push(viewingAsUserType)
        }
      }
      const userGroupsJson = JSON.stringify(userGroups)
      sessionStorage.setItem("userId", userId)
      sessionStorage.setItem('userGroups', userGroupsJson);
      sessionStorage.setItem('viewingAs', viewingAs);
      window.location.reload(false);
    } else {
      var error = 'an unknown error occurred'
      if (res.data.error) {
        error = res.data.error
      }
      alert(error)
    }

  }

  searchForUser(event, userType) {
    axios.get(`${API_ROOT}/user/?searchTerm=` + this.state.searchString + `&userType=` + userType, {headers: getApiHeaders()})
      .then(res => this.handleSearchResponse(res));
  }

  handleSearchResponse(res) {
    var alertMessage=''
    if (res.status === 401) {
      alertMessage = 'You are not authorized to search.'
    } else if (res.data) {
      if (res.data.error) {
        alertMessage =res.data.error
      } else {
        var searchResultsError = '';
        if (res.data.length === 0) {
          searchResultsError = 'no results found'
        }
        this.setState({
          searchResults: res.data,
          searchResultsError: searchResultsError
        })
      }
    } else {
      alertMessage = 'An unknown error occurred.'
    }
    if (alertMessage) {
      alert(alertMessage)
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Card>
          <CardHeader color="cirrusBlue" icon>
            <CardIcon color="cirrusBlue">
              <SettingsIcon />
            </CardIcon>
            <h4 id="organizationProvidersHeader" className={classes.cardIconTitle}>
              Mimic another user
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem  xs={12} sm={12} md={12} lg={12}>
                <Button color="cirrusBlue" id="resetMimicUserButton" onClick={event => this.handleChangeMimicUser(event, 'organization')}>
                  Reset
                </Button>
              </GridItem>
              <GridItem  xs={12} sm={12} md={3} lg={3}>
                select a dental office:
              </GridItem>
              <GridItem  xs={12} sm={12} md={9} lg={9}>
                <FormControl
                  fullWidth
                  className={classes.selectFormControl}
                >
                  <InputLabel
                    htmlFor="simple-select"
                    className={classes.selectLabel}
                  >
                    office
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={this.state.selectedMimicUser}

                    inputProps={{
                      id: "selectedMimicUser",
                      name: "selectedMimicUser",
                      onChange: event => this.handleChangeMimicUser(event, 'organization')
                    }}

                  >
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value=''
                    >
                      all
                    </MenuItem>
                    {this.state.dentistList.map((dentist) =>
                      <MenuItem classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }} key={dentist['id']} value={dentist['id']} >{dentist['name']}</MenuItem>
                    )}

                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                search for a patient
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <CustomInput
                  labelText="search"
                  id="searchString"
                  formControlProps={{
                    onChange: this.handleChange,
                    fullWidth: true,
                    margin: "dense"
                  }}
                  inputProps={{
                    value: this.state.searchString
                  }}
                  customStyle={this.state.customInputStyle}
                />
              </GridItem>
              <GridItem  xs={12} sm={12} md={3}>
                <Button color="cirrusBlue" id="resetMimicUserButton" onClick={event => this.searchForUser(event, 'patient')}>
                  search
                </Button>
              </GridItem>
              <GridItem  xs={12} sm={12} md={12}>
                <div style={{maxHeight: '300px', overflow: 'auto'}}>
                  <span>{this.state.searchResultsError}</span>
                  <ul>
                  {this.state.searchResults.map((searchResult, idx) => (
                    <li key={idx}>{searchResult.firstName} {searchResult.lastName} ({searchResult.email})
                      <Button color="cirrusBlue" id="resetMimicUserButton" value={searchResult.userId} onClick={event => this.handleChangeMimicUser(event, 'patient', searchResult.userId, searchResult.firstName + ' ' + searchResult.lastName)}>
                        Mimic
                      </Button>

                    </li>
                    )
                  )}
                  </ul>
                </div>
              </GridItem>

            </GridContainer>
          </CardBody>
        </Card>
      </div>
    )

  }


}

export default withStyles(style)(Settings);